$(window).on('turbolinks:load', () => {
  lazyload();
})